import { ConnectorIds } from '@/common/constants';
import { ConnectorType, IConnector } from '@/common/dto/connectors/Interface';

/**
 * Filter a list of connectors by type.
 *
 * @param connectors
 * @param type
 * @returns filteredConnectors
 */
export const filterByConnectorType = (
  connectors: IConnector[],
  type: ConnectorType
): IConnector[] => connectors?.filter((c) => c.type === type) ?? [];

/**
 * Returns a connector given a connector id
 *
 * @param connectors
 * @param id
 * @returns connector
 */
export const getConnectorById = (
  connectors: IConnector[],
  id: ConnectorIds
): IConnector | undefined => connectors?.find((c) => c.connectorId === id);

/**
 * Returns the name of the connector, if found, given an id.
 *
 * @param connectors
 * @param id
 * @returns name
 */
export const getConnectorName = (connectors: IConnector[], id: ConnectorIds): string =>
  getConnectorById(connectors, id)?.name ?? '';

/**
 * Returns if the connector is mappable
 *
 * @param connector
 * @returns isMappable
 */
export const isConnectorMappable = (connector: IConnector | undefined): boolean =>
  connector?.type === ConnectorType.CONNECTOR || connector?.connectorId === ConnectorIds.API;

/**
 * Returns if the connector can be a navigation target for workflow actions
 * (skip-ahead or go-back). Navigation differs from data mapping - approvals
 * are valid navigation targets but don't produce mappable data.
 *
 * @param connector
 * @returns isNavigable
 */
export const isConnectorNavigable = (connector: IConnector | undefined): boolean =>
  connector?.type === ConnectorType.CONNECTOR ||
  connector?.connectorId === ConnectorIds.API ||
  connector?.connectorId === ConnectorIds.Approval;
